
import { mdiMenu } from "@mdi/js"
export default {
    name: "HelpCenterNav",
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    data: () => {
        return {
            mdiMenu: mdiMenu,
            links: [
                { link: "/", text: "Zur Startseite" },
                { link: "app-datenschutz", text: "Datenschutz der Oabat-App" },
                { link: "nutzungsbedingungen", text: "Nutzungsbedingungen" },
                {
                    link: "nutzungsbedingungen-fuer-bildungseinrichtungen",
                    text: "Nutzungsbedingungen für Bildungseinrichtungen",
                },
                { link: "agb", text: "AGB" },
                { link: "agb-messe", text: "AGB der Oabat-Messen" },
                { link: "impressum", text: "Impressum" },
            ],
        }
    },
}
